import React from 'react';
import { Box, Button, Chip } from '@material-ui/core';
import { ExternalLink } from 'react-feather';
import { useTranslation } from 'react-i18next';

interface IDuplicatedLeadIndicator {
    isDuplicated?: boolean;
    duplicatedURL?: string;
}

export const DuplicatedLeadIndicator = ({
    isDuplicated = false,
    duplicatedURL,
}: IDuplicatedLeadIndicator) => {
    const { t } = useTranslation();

    if (!isDuplicated) return null;

    return (
        <Box
            component="span"
            display="inline-flex"
            alignItems="center"
            gridGap={8}
            ml={1}
        >
            <Chip
                color="primary"
                label={t('Leads.Duplicated')}
                variant="outlined"
            />
        </Box>
    );
};
